import {SiteBasics} from 'Common/SiteBasics';
import Assert from 'Common/Assert';
import {ArtistRoutes} from 'Common/artists/ArtistRoutes';
import {AdminRoutes} from 'Shared/admin/AdminRoutes';
import {VenueRoutes} from 'Shared/routes/VenueRoutes';
import {SiteType} from 'Common/SiteType';
import { BrowserId } from 'Browser/BrowserId';


export function selectRoutes(site:SiteBasics<BrowserId>)
{
	switch(site.type) {
		case SiteType.venue:	
			return (new VenueRoutes()).routes();

		case SiteType.artist:
			return (new ArtistRoutes()).routes();

		case SiteType.admin:
			return (new AdminRoutes()).routes();
	}
console.log('RoutesSelector site.type:',site.type);	
	Assert.check(false);
}

